export const BREAKPOINTS = {
    small: 0,
    medium: 480,
    large: 640,
    xlarge: 768,
    xxlarge: 1024,
    xxxlarge: 1600
};
